module.exports = __webpack_public_path__ + "img/logo-credible.3dc9be72.png";